var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 16H11.5002M14.5002 16H18.0002M2.00021 9H22.0002M2.00021 12C2.00021 8.46252 2.00021 6.69377 3.05301 5.5129C3.2214 5.32403 3.40699 5.14935 3.60767 4.99087C4.86234 4 6.74163 4 10.5002 4H13.5002C17.2588 4 19.1381 4 20.3927 4.99087C20.5934 5.14935 20.779 5.32403 20.9474 5.5129C22.0002 6.69377 22.0002 8.46252 22.0002 12C22.0002 15.5375 22.0002 17.3062 20.9474 18.4871C20.779 18.676 20.5934 18.8506 20.3927 19.0091C19.1381 20 17.2588 20 13.5002 20H10.5002C6.74163 20 4.86234 20 3.60767 19.0091C3.40699 18.8506 3.2214 18.676 3.05301 18.4871C2.00021 17.3062 2.00021 15.5375 2.00021 12Z",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.02db4c7427b6fe85c160e9d81e4e0ec2.svg";
export { ForwardRef as ReactComponent };